// extracted by mini-css-extract-plugin
module.exports = {"containerClassName":"_2kTqHYosMyQKjn_i0DNwyf"};